import { useDrag } from "@use-gesture/react";
import useWindowSize from "hooks/useWindowSize";
import { useRef } from "react";
import { animated, config, useSpring } from "react-spring";
import styled from "styled-components";

const Container = styled(animated.div)`
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  background-color: ${(props) => props.theme.colors.background};
  box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.16), 0 -3px 6px rgba(0, 0, 0, 0.23);
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 50px;
  touch-action: none;
  z-index: 1000;
`;

const Content = animated.div;

const Handle = styled.div`
  height: 24px;
  width: 100px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  touch-action: none;

  &:after {
    content: "";
    display: block;
    height: 3px;
    width: 50px;
    border-radius: 2px;
    background-color: ${(props) => props.theme.colors.body};
  }
`;

type DrawerProps = {
  forceActive?: boolean;
  children?: React.ReactNode;
};

export const Drawer = ({ children }: DrawerProps) => {
  const size = useWindowSize();
  const restPos = useRef(size.height - 200);
  const [{ y }, api] = useSpring(() => ({
    y: restPos.current,
    from: {
      y: size.height,
    },
  }));

  const open = () => {
    restPos.current = 0;
    api.start({ y: 0, immediate: false, config: config.default });
  };
  const close = (velocity = 0) => {
    restPos.current = size.height - 200;
    api.start({
      y: restPos.current,
      immediate: false,
      config: { ...config.default, velocity },
    });
  };

  const bind = useDrag(
    (state) => {
      const vy = state.velocity[1];
      const my = state.movement[1];

      const isOpen = restPos.current === 0;

      console.log(state.swipe);
      if (isOpen && state.swipe[1] === 1) {
        state.cancel();
        close();
      } else if (!isOpen && state.swipe[1] === -1) {
        state.cancel();
        open();
      } else if (state.last) {
        if (my < -250 && !isOpen) {
          open();
        } else if (isOpen && my > 200) {
          close(vy);
        } else if (isOpen) {
          open();
        } else {
          close();
        }
      } else {
        api.start({
          y: restPos.current + my,
          immediate: true,
        });
      }
    },
    {
      from: () => [0, y.get()],
      filterTaps: true,
      bounds: { top: 0 },
      rubberband: true,
    }
  ) as any;

  return (
    <Container style={{ y }} {...bind()}>
      <Handle />
      <Content>{children}</Content>
    </Container>
  );
};
